import { Seo } from "../components/Seo";
import { Reveal, MaskedLine, Label } from "../components/Reveal";
import { QuoteForm } from "../components/QuoteForm";
import { Mail, MapPin, Phone, Clock, Star } from "lucide-react";

const Contact = () => (
  <>
    <Seo
      title="Contact | Resineko"
      description="Contactez Resineko pour votre projet de revêtement de sol : résine, béton ciré, moquette de pierre ou peinture. Intervention partout en France."
      path="/contact"
    />
    <section className="noise-bg relative overflow-hidden bg-[#0A0A0A] pb-24 pt-40 md:pb-36 md:pt-52" data-testid="contact-page">
      <div
        className="pointer-events-none absolute inset-0 opacity-50"
        style={{ background: "radial-gradient(ellipse 70% 45% at 20% 0%, rgba(4,120,87,0.18), transparent)" }}
      />
      <div className="relative mx-auto max-w-7xl px-5 md:px-10">
        <span className="block overflow-hidden">
          <MaskedLine delay={0.1}><Label>Contact</Label></MaskedLine>
        </span>
        <h1 className="mt-6 font-serif text-4xl font-light leading-[1.02] text-[#F4F4F0] sm:text-5xl lg:text-6xl">
          <MaskedLine delay={0.25}>Échanger avec</MaskedLine>
          <MaskedLine delay={0.38}><em className="not-italic text-[#2FBF8F]">Resineko</em></MaskedLine>
        </h1>

        <div className="mt-16 grid gap-12 lg:grid-cols-12">
          <div className="space-y-6 lg:col-span-4">
            <Reveal>
              <a href="tel:+33783693101" data-testid="contact-phone" className="group block border border-white/10 bg-[#111111] p-8 transition-colors duration-300 hover:border-[#047857]/60">
                <Phone size={18} className="text-[#2FBF8F]" />
                <h2 className="mt-4 font-serif text-xl font-light text-[#F4F4F0]">Par téléphone</h2>
                <p className="mt-2 text-lg font-normal text-[#F4F4F0] transition-colors group-hover:text-[#2FBF8F]">07 83 69 31 01</p>
                <p className="mt-1 text-sm leading-relaxed text-[#8C8C8C]">
                  Appelez-nous pour parler directement de votre projet.
                </p>
                <p className="mt-3 flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-[#2FBF8F]">
                  <Clock size={13} /> Lun – Sam : 7h30 – 18h30
                </p>
              </a>
            </Reveal>
            <Reveal delay={0.05}>
              <div className="border border-white/10 bg-[#111111] p-8">
                <MapPin size={18} className="text-[#2FBF8F]" />
                <h2 className="mt-4 font-serif text-xl font-light text-[#F4F4F0]">Zone d'intervention</h2>
                <p className="mt-2 text-sm leading-relaxed text-[#8C8C8C]">
                  Basés à Daux (31700), dans la région toulousaine, nous intervenons partout en France.
                </p>
              </div>
            </Reveal>
            <Reveal delay={0.1}>
              <a href="mailto:resineko31@gmail.com" data-testid="contact-email" className="group block border border-white/10 bg-[#111111] p-8 transition-colors duration-300 hover:border-[#047857]/60">
                <Mail size={18} className="text-[#2FBF8F]" />
                <h2 className="mt-4 font-serif text-xl font-light text-[#F4F4F0]">Par écrit</h2>
                <p className="mt-2 text-lg font-normal text-[#F4F4F0] transition-colors group-hover:text-[#2FBF8F]">resineko31@gmail.com</p>
                <p className="mt-1 text-sm leading-relaxed text-[#8C8C8C]">
                  Ou décrivez votre projet via le formulaire ci-contre : nous revenons vers vous rapidement.
                </p>
              </a>
            </Reveal>
            <Reveal delay={0.15}>
              <a
                href="https://share.google/oB26YWKfBF2VXP4ye"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="contact-google-business"
                className="group block border border-white/10 bg-[#111111] p-8 transition-colors duration-300 hover:border-[#047857]/60"
              >
                <Star size={18} className="text-[#2FBF8F]" />
                <h2 className="mt-4 font-serif text-xl font-light text-[#F4F4F0]">Nos avis Google</h2>
                <p className="mt-2 text-sm leading-relaxed text-[#8C8C8C]">
                  Retrouvez notre fiche Google Business Profile et les avis de nos clients.
                </p>
                <p className="mt-3 text-xs uppercase tracking-[0.2em] text-[#2FBF8F]">Voir notre fiche Google →</p>
              </a>
            </Reveal>
          </div>
          <div className="lg:col-span-8">
            <Reveal delay={0.15}>
              <div className="border border-white/10 bg-[#111111] p-6 md:p-10">
                <QuoteForm />
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  </>
);

export default Contact;
